export default "/images/close.png?e077cb8f2feb18a3afdf5050b2e5b874";